import React from 'react';
import SEO, { SITE_URL } from '../components/SEO';

const About = () => {
  return (
    <div className="min-h-screen pt-24 pb-16" data-testid="about-page">
      <SEO title="About Us - Our Story" description="Studio Crochet by Ekta Singh. Premium ethnic wear brand crafting handmade sarees, lehengas, and Indo-Western outfits. Based in Noida, India." canonical={`${SITE_URL}/about`} />
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="font-cormorant text-4xl sm:text-5xl lg:text-6xl leading-none mb-12 text-center" data-testid="about-heading">Our Story</h1>
        
        <div className="max-w-3xl mx-auto space-y-8">
          <div className="aspect-video overflow-hidden bg-[#F3EFE6] mb-12">
            <img 
              src="https://static.prod-images.emergentagent.com/jobs/62cdf97b-2a96-4971-b0b6-e9fea3545049/images/3aad39b5816d005529793f8c54063e6fd7d8457a07645ece120e5a0940443c0c.png"
              alt="Studio Crochet"
              className="w-full h-full object-cover"
            />
          </div>

          <div className="space-y-6" data-testid="about-content">
            <p className="font-outfit text-base leading-relaxed text-[#4A463F]">
              Studio Crochet by Ekta Singh is a premium ethnic wear brand that celebrates the timeless beauty of Indian craftsmanship. Founded with a passion for preserving traditional artistry while embracing contemporary design, we create pieces that tell a story.
            </p>

            <p className="font-outfit text-base leading-relaxed text-[#4A463F]">
              Each garment in our collection is thoughtfully curated to offer you the finest quality fabrics, intricate detailing, and a perfect blend of tradition and modernity. From elegant sarees to stunning lehengas, our designs are crafted to make every woman feel confident and beautiful.
            </p>

            <p className="font-outfit text-base leading-relaxed text-[#4A463F]">
              We believe in creating pieces that are not just clothes, but expressions of art. Our commitment to quality, attention to detail, and dedication to customer satisfaction have made Studio Crochet a trusted name in ethnic fashion.
            </p>

            <div className="pt-8 border-t border-[#EBE4D5]">
              <h2 className="font-cormorant text-2xl sm:text-3xl mb-4 text-[#C29B57]">Our Values</h2>
              <ul className="space-y-3">
                <li className="font-outfit text-base text-[#4A463F]">• Quality craftsmanship and attention to detail</li>
                <li className="font-outfit text-base text-[#4A463F]">• Preserving traditional Indian artistry</li>
                <li className="font-outfit text-base text-[#4A463F]">• Contemporary designs with timeless appeal</li>
                <li className="font-outfit text-base text-[#4A463F]">• Customer satisfaction and personalized service</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;